<vex-page-layout mode="card">
    <vex-page-layout-header class="pb-16 flex flex-col items-start justify-center">
        <div [class.px-gutter]="true" class="w-full flex flex-col sm:flex-row justify-between">
            <div>
                <h1 class="title mt-0 mb-1">Formulario de Ingreso</h1>
                <vex-breadcrumbs [crumbs]="crumbs"></vex-breadcrumbs>
            </div>
        </div>
    </vex-page-layout-header>

    <vex-page-layout-content>
        <div class="card">
            <mat-tab-group>
                <mat-tab label="{{formLabel}}">
                    <div class="p-6">
                        <div class="grid grid-flow-col gap-3">

                        </div>

                        <div class="grid grid-flow-col gap-3">
                            <div class="col-span-1">
                                <div class="px-6 py-4 border-b flex items-center">
                                    <h2 class="title m-0 flex-auto">Datos del caso</h2>
                                    <button *ngIf="this.actionType === 'update'" mat-icon-button type="button" matTooltip="Publicar"
                                        (click)="publicar()">
                                        <mat-icon class="text-secondary" svgIcon="mat:start"></mat-icon>
                                    </button>
                                </div>
                                <div class="px-6 py-4 flex flex-col">
                                    <form (ngSubmit)="save()" [formGroup]="form" novalidate>
                                        <div class="px-6 py-4 flex flex-col">
                                            <div class="flex flex-col sm:flex-row sm:gap-4">
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Documento</mat-label>
                                                    <input matInput formControlName="documento">
                                                </mat-form-field>
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Complemento</mat-label>
                                                    <input matInput formControlName="complemento">
                                                </mat-form-field>
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Nacionalidad</mat-label>
                                                    <mat-select formControlName="nacionalidad" [(ngModel)]="selectedOption">
                                                        <mat-option *ngFor="let item of nacionalidades" [value]="item"> {{item}} </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div class="flex flex-col sm:flex-row sm:gap-4">
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Nombres</mat-label>
                                                    <input matInput formControlName="nombres">
                                                </mat-form-field>
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Apellido paterno</mat-label>
                                                    <input matInput formControlName="apellidoPaterno">
                                                </mat-form-field>
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Apellido materno</mat-label>
                                                    <input matInput formControlName="apellidoMaterno">
                                                </mat-form-field>
                                            </div>
                                            <div class="flex flex-col sm:flex-row sm:gap-4">
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Fecha de nacimiento</mat-label>
                                                    <input formControlName="fechaNacimiento"
                                                        (click)="formBirthdatePickerRef.open()"
                                                        (focus)="formBirthdatePickerRef.open()"
                                                        [matDatepicker]="formBirthdatePickerRef" matInput readonly>
                                                    <mat-datepicker-toggle [for]="formBirthdatePickerRef"
                                                        matSuffix></mat-datepicker-toggle>
                                                    <mat-datepicker #formBirthdatePickerRef></mat-datepicker>
                                                </mat-form-field>
                                                <!--!<mat-form-field class="flex-auto">
                                                    <mat-label>Edad Aprox.</mat-label>
                                                    <input matInput formControlName="edadAprox">
                                                </mat-form-field>-->
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Sexo</mat-label>
                                                    <mat-select formControlName="sexo">
                                                        <mat-option *ngFor="let item of generos" [value]="item"> {{item}} </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div class="flex flex-col sm:flex-row sm:gap-4">
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Fecha desaparición</mat-label>
                                                    <input formControlName="fechaDesaparicion"
                                                        (click)="formDatepickerRef.open()"
                                                        (focus)="formDatepickerRef.open()"
                                                        [matDatepicker]="formDatepickerRef" matInput readonly>
                                                    <mat-datepicker-toggle [for]="formDatepickerRef"
                                                        matSuffix></mat-datepicker-toggle>
                                                    <mat-datepicker #formDatepickerRef></mat-datepicker>
                                                </mat-form-field>
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Hora</mat-label>
                                                    <input matInput formControlName="horaDesaparicion" type="time">
                                                </mat-form-field>
                                            </div>
                                            <div class="flex flex-col sm:flex-row sm:gap-4">
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Departamento</mat-label>
                                                    <mat-select formControlName="departamento">
                                                        <mat-option *ngFor="let item of departamentos" [value]="item"> {{item}} </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Municipio</mat-label>
                                                    <input matInput formControlName="municipio">
                                                </mat-form-field>
                                            </div>
                                            <div class="flex flex-col sm:flex-row sm:gap-4">
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Color cabellos</mat-label>
                                                    <input matInput formControlName="colorCabellos">
                                                </mat-form-field>
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Color ojos</mat-label>
                                                    <input matInput formControlName="colorOjos">
                                                </mat-form-field>
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Tez (Piel)</mat-label>
                                                    <input matInput formControlName="tez">
                                                </mat-form-field>
                                            </div>
                                            <div class="flex flex-col sm:flex-row sm:gap-4">
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Estatura</mat-label>
                                                    <input matInput formControlName="estatura">
                                                </mat-form-field>
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Peso</mat-label>
                                                    <input matInput formControlName="peso">
                                                </mat-form-field>
                                            </div>
                                            <div class="flex flex-col sm:flex-row sm:gap-4">
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Vestimenta</mat-label>
                                                    <input matInput formControlName="vestimenta">
                                                </mat-form-field>
                                            </div>
                                            <div class="flex flex-col sm:flex-row sm:gap-4">
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Referencia (Nro. telefono)</mat-label>
                                                    <input matInput formControlName="referencia">
                                                </mat-form-field>
                                            </div>
                                            <!--<div class="flex flex-col sm:flex-row sm:gap-4">
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Señas particulares</mat-label>
                                                    <textarea matInput formControlName="senias"></textarea>
                                                </mat-form-field>
                                            </div>-->
                                            <div class="flex flex-col sm:flex-row sm:gap-4">
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Lugar del hecho</mat-label>
                                                    <textarea matInput formControlName="lugarHecho"></textarea>
                                                </mat-form-field>
                                            </div>
                                            <div class="flex flex-col sm:flex-row sm:gap-4">
                                                <mat-form-field class="flex-auto">
                                                    <mat-label>Desaparecio</mat-label>
                                                    <textarea matInput formControlName="resumen"></textarea>
                                                </mat-form-field>
                                            </div>
                                            <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="4px">
                                                <mat-slide-toggle color="primary" labelPosition="before"
                                                    formControlName="encontrado">Encontrado
                                                </mat-slide-toggle>
                                            </div>
                                            <div class="flex items-center justify-end gap-2">
                                                <button color="primary" mat-raised-button type="submit"
                                                    [disabled]="form.invalid">{{actionType ==='update'?
                                                    appSettings.DIALOG_BUTTON_UPDATE_POSITIVE:
                                                    appSettings.DIALOG_BUTTON_PERSIST_POSITIVE}}</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="col-span-1" *ngIf="this.actionType === 'update'">
                                <div class="px-6 py-4 border-b flex items-center">
                                    <h2 class="title m-0">Fotografías</h2>
                                </div>

                                <div class="px-gutter py-4 grid grid-cols-2 sm:grid-cols-1 gap-6">
                                    <img class="rounded w-full" [src]="foto()" />
                                    <div class="content-center">
                                        <h3 class="text-sm font-bold tracking-tight text-center">
                                            Foto del desaparecido
                                            <button matSuffix mat-icon-button aria-label="Serial" type="button"
                                                (click)="updateFotografia()">
                                                <mat-icon svgIcon="mat:create_new_folder"></mat-icon>
                                            </button>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </vex-page-layout-content>
</vex-page-layout>